import AppBar from '../AppBar/AppBar';
import Button from '../Button/Button';
import Title from '../Typography/Title';
import BodyText from '../Typography/BodyText';
import styles from './LandingPageScreen.css';
import useTranslation from '../../../localization/i18n.context';
import { CloseWebviewEvent } from '../../../sdk/close.webview.event';
import useConfig from '../../../config/config.context';
import CaasStorageKeys from '../../../constants/caas.storage.keys';
import NavigationUtils from '../../../utils/navigation.utils';
import { DeeplinkEvent } from '../../../sdk/deeplink.event';
import { renderIf } from '../../../utils/render.utils';

export default function LandingPageScreen({
  className = '',
  image,
  title,
  subtitle = '',
  organization,
}) {
  const { t } = useTranslation();
  const { config } = useConfig();
  const isLoggedIn =
    config[CaasStorageKeys.CONFIG] &&
    config[CaasStorageKeys.CONFIG].token &&
    config[CaasStorageKeys.CONFIG].token != null &&
    config[CaasStorageKeys.CONFIG].token !== '' &&
    config[CaasStorageKeys.CONFIG].token !== 'null';

  const onCloseClick = () => {
    CloseWebviewEvent.closedByUser();
  };

  const handleApplyClick = () => {
    if (isLoggedIn) {
      NavigationUtils.navigate(NavigationUtils.Routes.KYC, true, {
        organization,
      });
    } else {
      DeeplinkEvent.loginAndRedirect(
        `${NavigationUtils.Routes.KYC}?organization=${organization}`,
      );
    }
  };
  return (
    <div className={`${className} ${styles.main}`}>
      <AppBar
        onCloseClick={onCloseClick}
        className={`${styles['fixed-bar']}`}
      />

      <div className={styles.content}>
        <div className={styles['feedback-image']}>
          <img src={image} width={160} height={160} />
        </div>

        <div className={styles.text}>
          <div className={styles['feedback-title']}>
            <Title text={title} className="text-center" />
          </div>
          {renderIf(
            !!subtitle,
            <div className={styles['feedback-text']}>
              <BodyText text={subtitle} className="text-center" />
            </div>,
          )}
        </div>
      </div>

      <div className={`${styles['fixed-cta']} ${styles.actions}`}>
        <Button onClick={handleApplyClick} type={Button.Type.SECONDARY}>
          {t('Apply')}
        </Button>
        <Button
          onClick={onCloseClick}
          type={Button.Type.TERTIARY}
          className={styles['secondary-action']}
        >
          {t('Skip for now')}
        </Button>
      </div>
    </div>
  );
}
